import { MutationTree } from 'vuex';
import { RootState } from '@/store/types';
import { AdsState, AdsMutations } from './types';
import Ad from './ad';
import { ListStatus, EditableStatus } from '@/store/types';
import Vue from 'vue';
import { updateEditable } from '@/store/utils/editable';

export const mutations: MutationTree<AdsState> = {
  [AdsMutations.SET_ALL](state, ads: Ad[]) {
    state.list = ads;
  },

  [AdsMutations.SET_ALL_STATUS](state, status: ListStatus) {
    state.listStatus = status;
  },

  [AdsMutations.SET_EDITABLE](state, ad: Ad | null) {
    Vue.set(state, 'editable', ad);
    Vue.set(state, 'initialEditable', ad ? Ad.clone(ad) : null);
  },

  [AdsMutations.SET_EDITABLE_STATUS](state, status: EditableStatus) {
    state.editableStatus = status;
  },

  [AdsMutations.SET_LIST_PAGINATION](state, pagination: AdsState['listPagination']) {
    state.listPagination = pagination;
  },

  [AdsMutations.UPDATE_EDITABLE]: updateEditable<AdsState>('editable'),
  [AdsMutations.UPDATE_INITIAL_EDITABLE]: updateEditable<AdsState>('initialEditable'),

  [AdsMutations.SET_PRODUCTS](state, products: { id: number; title: string }[]) {
    state.products = products;
  },

  [AdsMutations.SET_COUNTRIES](state, countries: { id: number; title: string }[]) {
    state.countries = countries;
  },
};
